var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckFalse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FF2F56;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;stroke:#FF2F56;stroke-width:2;stroke-linecap:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_907",
    transform: "translate(-1465.367 -459.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_287_1_",
    transform: "translate(1466.367 460.588)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_286_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_285_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_233_1_",
    className: "st0",
    d: "M28,14c0,7.7-6.3,14-14,14S0,21.7,0,14S6.3,0,14,0l0,0C21.7,0,28,6.3,28,14z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_236",
    className: "st1",
    d: "M1485.9,468.5l-11.6,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_237",
    className: "st1",
    d: "M1485.9,480.1l-11.6-11.6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFalse);
export default __webpack_public_path__ + "static/media/check-false.95cb7a1240fd83aa30d93497be714ae3.svg";
export { ForwardRef as ReactComponent };